/* Deactivated */

import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { IPlanContent } from '../typings/planContent.types';
import { originGoVariableContent } from './originGoVariable';
import {
  defaultEstimatesDialog,
  defaultKeyDetails,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

export const pwcVariableContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin PwC Employee Go Variable']),
  content: {
    ...originGoVariableContent.content,

    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    onlineCredits: undefined,
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions.html',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
